// extracted by mini-css-extract-plugin
export default {"container":"baseLayout_container__k37uX","content":"baseLayout_content__rp6sN"};